import { type CanvasNodeMedia } from '../../types';
import { DEFAULT_CANVAS_IMAGE_HEIGHT, DEFAULT_CANVAS_IMAGE_WIDTH } from './canvasAssetDropConstants';
import { type CanvasAssetPayload, type ImageNodeSource } from './canvasAssetDropTypes';

/**
 * Maps canvas asset payloads (from drag) to ImageNodeSource for buildImageNodes.
 * Filters to assets with media and applies default dimensions when missing.
 */
export function payloadToImageNodeSources(assets: CanvasAssetPayload[]): ImageNodeSource[] {
  return assets
    .filter(
      (asset): asset is CanvasAssetPayload & { media: CanvasNodeMedia } =>
        !!(asset.media?.image || asset.media?.original),
    )
    .map((asset) => ({
      assetId: asset.assetId,
      fileName: asset.title || asset.importedName || 'Image',
      height: asset.height ?? DEFAULT_CANVAS_IMAGE_HEIGHT,
      media: asset.media,
      versionId: asset.id,
      width: asset.width ?? DEFAULT_CANVAS_IMAGE_WIDTH,
    }));
}
